export const convertNumber = (num, isToFixed) => {
	if (num !== undefined && num !== null && num !== '') {
		const strNum = num.toString()
		const parts = strNum.split('.')
		const decimalLen = parts[1] ? parts[1].length : 0

		if (isToFixed && decimalLen < 2) {
			return (
				Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100
			).toFixed(2)
		}

		return strNum
	} else return ''
}
